import { AbstractPreset, config } from "./AbstractPreset";

export default class RectangleCircleNone extends AbstractPreset {
	getName(): string {
		return 'rectangleCircleNone';
	}

	getConfig(): config {
		return {
			"base": {
				"shape": "rectangle",
				"presetShape": this.getName(),
				"primitives": {
					"width": 50,
					"length": 50
				},
			},
			"drillholes": {
				"type": "none"
			},
			"cutouts": [
				{
					"type": "shape",
					"shape": "circle",
					"primitives": {
						"diameter": 20
					},
					"modifiers": [],
					"position": {
						"left": 150,
						"bottom": 250,
						"rotation": 0
					}
				}
			],
		};
	}
}
